import Dashboard from "./containers/Dashboard";
import Module from "./containers/Module";
import CourseModule from "./containers/ModuleCards";

const routes = [
    {
        path: "/dashboard",
        element: <Dashboard />,
    },
    {
        path: "/courseModule",
        element: <CourseModule />,
    },
    {
        path: "/module/:id",
        element: <Module />,
    },
];

export default routes;
